// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';

import desktopImg from '../../../../../assets/img/minimal/checkout-disabled.png';
type Props = {
  handleClose: (e?: any) => void,
  open: boolean,
};

const useStyles = makeStyles(theme => ({
  defaultModal: {
    '& .MuiPaper-root': {
      background: '#18003D',
      margin: theme.spacing(4, 4, 0, 4),
    },
  },
  img: {
    width: '100%',
    maxWidth: '100%',
  },
}));

export default function CustomCheckoutDisabledModal({
  open,
  handleClose,
}: Props) {
  const classes = useStyles();
  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.defaultModal}
    >
      <Link to="/tiers-list" className={classes.modal}>
        <img src={desktopImg} className={classes.img} alt="" />
      </Link>
    </CustomModal>
  );
}
